import React, { useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../scss/dhp.scss";

let style = Object.assign({}, global);

const TemplateInfo = ({ templateInfo }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [templateType, setTemplateType] = useState();

  useEffect(() => {
    if (templateInfo?.type) {
      let tempType = templateInfo.type
        .toLowerCase()
        .replace(/twitter/gi, "X/Twitter")
        .replace(/youtube/gi, "YouTube")
        .replace(/\b\w/g, match => match.toUpperCase());
      setTemplateType(tempType);
    }
  }, [templateInfo]);

  return (
    <div className={style["w-100"]}>
      <figure className={style["template-image"]}>
        <span>
          <img className={style["img-fluid"]} onLoad={() => setIsImageLoaded(true)} src={templateInfo?.thumb} />
        </span>
      </figure>
      {isImageLoaded && (
        <div className={style["template-info"]}>
          <p className={cx(style["fw-6"], style["m-0"])}>{templateInfo?.category}</p>
          <p className={cx(style["mb-3"], style["text-capitalize"])}>{templateType} Template</p>
          <span>
            Customize this template now and share it with the world to <br /> get more likes, followers, and hearts.
          </span>
        </div>
      )}
    </div>
  );
};

TemplateInfo.propTypes = {
  templateInfo: PropTypes.object.isRequired,
};

export default TemplateInfo;
